import { render, staticRenderFns } from "./WIPView.vue?vue&type=template&id=3d671eca&scoped=true&"
import script from "./WIPView.vue?vue&type=script&lang=js&"
export * from "./WIPView.vue?vue&type=script&lang=js&"
import style0 from "./WIPView.vue?vue&type=style&index=0&id=3d671eca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d671eca",
  null
  
)

export default component.exports